const ServiceHero = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-primary/5 to-white">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-6xl font-extrabold text-dark mb-6">
          Nuestros <span className="text-primary">Servicios</span>
        </h1>
        <p className="text-xl text-secondary max-w-3xl mx-auto leading-relaxed">
          Soluciones completas en hormigón decorativo y piscinas de arena para transformar tus espacios con calidad, diseño y durabilidad
        </p>
      </div>
    </section>
  );
};

export default ServiceHero;